export default class Region {

    constructor(public id: number, public name: string) {
    }
}
